var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTournament(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 136 136",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard2",
    x: 0,
    y: 0,
    width: 135.583,
    height: 135.583,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.726,39.856c10.839,0 21.182,7.414 21.182,16.547c-0,9.132 -10.713,20.43 -31.276,29.026c2.914,-2.474 9.08,-9.863 9.294,-10.827c-0,0 0.529,-0.458 0.8,-0.649c8.716,-6.152 10.434,-11.726 10.434,-17.55c0,-4.946 -1.581,-7.447 -6.061,-10.35c-1.139,-0.738 -4.373,-1.607 -4.373,-1.607l-0,-4.547c-0,-0 0.015,-0.029 -0,-0.043Z",
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.857,39.856c-10.84,0 -21.182,7.414 -21.182,16.547c-0,9.132 10.712,20.43 31.276,29.026c-2.914,-2.474 -9.08,-9.863 -9.294,-10.827c-0,0 -0.529,-0.458 -0.8,-0.649c-8.716,-6.152 -10.435,-11.726 -10.435,-17.55c0,-4.946 1.581,-7.447 6.062,-10.35c1.138,-0.738 4.373,-1.607 4.373,-1.607l-0,-4.547c-0,-0 -0.015,-0.029 -0,-0.043Z",
    style: {
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.518,72.261l-0.226,-45.868l-63.136,-0l0.226,45.868c1.787,8.973 19.93,18.656 31.568,18.656c11.669,0 29.519,-9.062 31.557,-18.639l0.011,-0.006l-0,-0.011l-0,0l-0,0Zm-31.681,-37.888c2.408,0 6.39,14.372 6.39,14.372c-0,0 14.899,-0.654 15.643,1.636c0.744,2.291 -11.694,10.519 -11.694,10.519c0,-0 5.227,13.967 3.278,15.383c-1.948,1.415 -13.617,-7.872 -13.617,-7.872c0,0 -11.669,9.287 -13.617,7.872c-1.948,-1.416 3.278,-15.383 3.278,-15.383c0,-0 -12.438,-8.228 -11.694,-10.519c0.744,-2.29 15.643,-1.636 15.643,-1.636c0,0 3.982,-14.372 6.39,-14.372Zm31.681,37.888l-0.007,-0.006l0.002,0.006l0.005,0l-0,0Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.167,86.579c-2.169,0.68 -4.466,0.675 -6.885,0l-0,18.637l6.885,-0l0,-18.637Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.349,98.855l-7.249,0l-20.643,10.335l48.535,-0l-20.643,-10.335Z",
    style: {
      fill: "currentColor"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTournament);
export default __webpack_public_path__ + "static/media/tournament.8630a3fe.svg";
export { ForwardRef as ReactComponent };